import { apiClient } from "./apiClient";

export const login = async (username, password) => {
    return apiClient.post("/auth/login", { username, password });
};

export const register = async (datos) => {
    return apiClient.post("/auth/register", datos);
};
